module.exports = __webpack_public_path__ + "img/MOSTBET.3c5a88c3.svg";